<template>
  <div class="card has-width-600">
    <div class="card-header">
      <div class="card-header-title is-size-4">Forgot your password?</div>
    </div>
    <div class="card-content">
      <form action method="POST" @submit.prevent="forgotPassword">
        <b-field
          label="Email"
          :type="{'is-danger': errors.has('email')}"
          :message="errors.first('email')"
        >
          <b-input
            v-model="email"
            name="email"
            placeholder="Please enter your Email"
            v-validate="'required|email'"
          ></b-input>
        </b-field>

        <div class="field has-margin-top-30">
          <button
            class="button is-primary is-pulled-right has-margin-bottom-30"
            :class="{'is-loading': loading, 'is-disabled': loading}"
          >
            <span>Send Reset Link</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import ForgotPasswordMutation from "../api/graphql/mutations/ForgotPassword";
export default {
  name: "forgot-password-card",

  data() {
    return {
      email: null,
      loading: false,
      forgotPasswordFeedback: null
    };
  },

  methods: {
    forgotPassword() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        const forgotEmail = this.email;
        this.loading = true;

        this.$apollo
          .mutate({
            mutation: ForgotPasswordMutation,
            variables: {
              data: { email: forgotEmail }
            }
          })
          .then(({ data }) => {
            this.forgotPasswordFeedback = data.forgotPassword;

            if (this.forgotPasswordFeedback.status == "EMAIL_SENT") {
              this.$toast.open({
                duration: 5000,
                message: this.forgotPasswordFeedback.message,
                type: "is-success"
              });

              this.email = null;
              this.$parent.close();
            }

            if (this.forgotPasswordFeedback.status == "EMAIL_NOT_SENT") {
              this.$toast.open({
                duration: 3000,
                message: "Invalid email address provided",
                type: "is-danger"
              });
            }
          })
          .catch(err => {
            this.$toast.open({
              duration: 3000,
              message: "An error occured, please try again.",
              type: "is-danger"
            });
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.has-width-600 {
  width: 600px;
}
</style>
